

export const environment = {
    production: false,
    url: 'https://bbeatz-api-cci-staging.stacknize.com/rbt',
    iamge: 'assets/1.svg',
    siteKey: '6Lc7M2QrAAAAAOxdRjBa2LNlqD2_ZK2GfHyj6mud'
}